import React from 'react';
import './style.css';

class Aba extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        
    }
  }
  render(){
    return <div>
        <p>
         I am advancing in my knowledge of level design<br/>
         Map editors I know how to use: Hammer Editor<br/>
         Cryengine 2 Sandbox 2<br/>
         and J.A.C.K Hammer (Half-life 1)<br/>
        </p>
    </div>
  };
}

export default Aba;